import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { CompanyService, DocumentService } from '../../services';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';
import { AolService } from '../../services/aol';
import { AppFilter } from '@app/shared/models';
import { EditSharesModal } from '../edit-shares/edit-shares-component';
import { CommonServices } from '@app/shared/services';
import { forkJoin } from 'rxjs';
import { tap, switchMap } from 'rxjs/operators';

interface INewDirectorModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
@Component({
  selector: 'app-new-company-modal',
  templateUrl: './new-company-modal.component.html',
  styleUrls: ['./new-company-modal.component.scss'],
})
export class NewCompanyModalComponent implements OnInit, OnDestroy {
  pendingArr: boolean[] = [];
  companyDirectorForm: FormGroup;
  formSubmitAttempt: boolean;
  countries: Array<any> = [];
  typeId: string = 'Individual';
  typeName;
  affiliateTypeId;
  success: any;
  error: any;
  checkbox: boolean = false;
  filter: AppFilter = new AppFilter();
  organizationId: string;
  companyAffiliateTypes!: any[];
  allAffiliateTypes!: any[];
  selectedFilePhoto: File | null = null;
  fileNamePhoto: string = '';
  imageUrl: string | ArrayBuffer | null = '';
  companyType = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor?.companyType?.optionId;
  companyDirectors: any[] = [];
  baseUrl = environment.API_SERVER;
  isAddBtnDisabled: boolean = true;
  isStep1BtnDisabled: boolean = true;
  uploadFormData: any;
  replyForm: FormGroup;
  resultToBeAdded;
  typeStructure;
  organization;
  secondExistingPage: boolean = false;

  companyDirector;
  shareHoldingAmount;
  usePercentage: boolean = false;
  showCapital: boolean = false;

  companyOwnershipTypes: any[] = [];
  companyTypes: any[] = [];
  meansOfIdentifications: any[] = [];

  selectedCompanyOwnershipType = '';
  selectedCompanyType = '';

  verifyCompanyName = '';
  verifyOptions = [
    { name: 'Yes', value: 'yes' },
    { name: 'No', value: 'no' },
  ];

  linkOrAddValue = 'add';
  linkOrAdd = [
    { name: 'Link existing individual', value: 'link' },
    { name: 'Add a new individual', value: 'add' },
  ];

  company: any = {};

  step: number = 1;

  supportingDocumentError: string = '';
  supportingDocuments: File[] = [];
  documents:
    | {
        documentId: string;
        documentPath: string;
      }[]
    | null[] = [null, null];

  previousDirector;
  bizProvider: Array<any> = [];

  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<INewDirectorModalContext, void, void>,
    private documentSvc: DocumentService,
    private companyOwnershipService: CompanyOwnershipService,
    private AolService: AolService,
    private commonService: CommonServices
  ) {
    this.countries = this.modal.context.data.countries;
    this.usePercentage = this.modal.context.data?.usePercentage;
    this.previousDirector = this.modal.context.data.previousDirector;
    this.typeStructure = this.modal.context.data.item;
    this.affiliateTypeId = this.modal.context.data.affiliateTypeId;
    this.shareHoldingAmount =
      this.modal.context.data.shareHoldingAmount.totalShareCapital;
    this.typeName = this.modal.context.data.affiliateTypeName;
    this.organization = JSON.parse(window.localStorage.getItem('user'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 100 });
    this.companyDirectorForm = fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
      middleName: [''],
      businessInformationProvider: [''],
      businessInformationProviderId: [''],
      shareholderType: [''],
      companyName: ['', Validators.required],
      companyRegNumber: ['', Validators.required],
      gender: ['', Validators.required],
      reCompanyEmail: [''],
      companyEmail: [''],
      nationalityId: ['', Validators.required],
      countryOfOriginId: ['', Validators.required],
      nationalIdNumber: [''],
      meansOfIdentificationId: [''],
      identificationNumber: [''],
      identificationDocument1Id: [''],
      identificationDocument1Path: [''],
      identificationDocument2Id: [''],
      identificationDocument2Path: [''],
      companyOwnershipTypeId: ['', Validators.required],
      organizationOwnershipId: [''],
      shareholding: [0, Validators.required],
      actionType: [''],
      shareCapital: [this.shareHoldingAmount],
      shareAllocated: ['', Validators.required],
      actualCompanyTypeId: [''],
      rcNumber: [''],
      verifyCompanyName: [null],
      linkOrAddValue: [null],
      photographDocumentId: [''],
      photographDocumentPath: [''],
    });

    // this.companyDirectorForm
    //   .get('businessInformationProvider')
    //   .valueChanges.subscribe((value) => {
    //     // console.log(value);
    //     this.companyDirectorForm
    //       .get('businessInformationProviderOptionId')
    //       .setValue(value.optionId);
    //   });

    this.replyForm = fb.group({
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT', Validators.required],
      documentName: ['PROFILE_PHOTO', Validators.required],
      document: ['', Validators.required],
      attachment: [true],
      documentDescription: ['string'],
    });
    if (this.modal.context.isEdit) {
      this.companyDirector = modal.context.data.director;

      if (this.companyDirector.identificationDocument1Id) {
        this.documents[0] = {
          documentId: this.companyDirector.identificationDocument1Id,
          documentPath: this.companyDirector.identificationDocument1Path,
        };
      }

      if (this.companyDirector.identificationDocument2Id) {
        this.documents[1] = {
          documentId: this.companyDirector.identificationDocument2Id,
          documentPath: this.companyDirector.identificationDocument2Path,
        };
      }

      this.companyDirectorForm.patchValue(this.companyDirector);
      this.companyDirectorForm
        .get('shareAllocated')
        .setValue(
          (modal.context.data.director.shareholding / 100) *
            modal.context.data.shareHoldingAmount.totalShareCapital
        );
    }
    this.companyDirectorForm
      .get('shareAllocated')
      .valueChanges.subscribe((value) => {
        const sharePercentage = (value / this.shareHoldingAmount) * 100;

        if (sharePercentage > 100) {
          this.error = 'Share percentage cannot be greater than 100';
          // set company director error
          this.companyDirectorForm.get('shareholding').setErrors({
            invalid: true,
          });
          return;
        }

        if (
          sharePercentage +
            (this.modal.context.data?.totalUsedSharesPercentage /
              this.shareHoldingAmount) *
              100 >
          100
        ) {
          this.error =
            'Share percentage cannot be greater than Total Share Capital';
          // set company director error
          this.companyDirectorForm.get('shareholding').setErrors({
            invalid: true,
          });
          return;
        }
        this.calculateShareholding(value);
      });
    this.companyDirectorForm
      .get('shareCapital')
      .valueChanges.subscribe((value) => {
        this.calculateShareholding(value);
      });
    if (!this.modal.context.isEdit) {
      this.getCompanyOwnershipTypes();
      this.getCompanyTypes();
    }
    this.getMeansOfIdentification();
    this.getBizProvider();
  }

  nextStep() {
    if (this.step === 1) {
      if (
        this.companyDirectorForm.get('companyOwnershipTypeId').value ===
        'foreign_owned'
      ) {
        this.step = 3;
        return;
      }
      this.getCompanyName();
      return;
    }

    if (this.step === 2) {
      if (!this.companyDirectorForm.value.verifyCompanyName) {
        this.error = 'Please select an option';
        return;
      }

      if (this.companyDirectorForm.value.verifyCompanyName === 'yes') {
        this.step++;
        return;
      }

      this.previousStep();

      return;
    }

    this.step++;
  }

  checkStep1BtnDisabled() {
    if (this.pendingArr.length) {
      this.isStep1BtnDisabled = true;
      return;
    }

    if (this.companyDirectorForm.get('companyOwnershipTypeId').invalid) {
      this.isStep1BtnDisabled = true;
      return;
    }

    if (
      this.companyDirectorForm.get('companyOwnershipTypeId').value ===
      'foreign_owned'
    ) {
      if (
        !this.companyDirectorForm.get('companyRegNumber').value ||
        !this.companyDirectorForm.get('companyName').value ||
        !this.companyDirectorForm.get('businessInformationProvider').value ||
        !this.companyDirectorForm.get('businessInformationProviderId').value ||
        !this.companyDirectorForm.get('companyEmail').value ||
        this.companyDirectorForm.get('companyEmail').value !==
          this.companyDirectorForm.get('reCompanyEmail').value
      ) {
        this.isStep1BtnDisabled = true;
        return;
      }
    }

    if (
      this.companyDirectorForm.get('companyOwnershipTypeId').value !==
      'foreign_owned'
    ) {
      if (!this.companyDirectorForm.get('rcNumber').value) {
        this.isStep1BtnDisabled = true;
        return;
      }
      if (!this.companyDirectorForm.get('actualCompanyTypeId').value) {
        this.isStep1BtnDisabled = true;
        return;
      }
    }

    this.isStep1BtnDisabled = false;
  }

  previousStep() {
    this.step = 1;
  }

  getCompanyName() {
    this.callStarted();
    this.companySvc
      .getCompanyName({
        companyTypeId: this.companyDirectorForm.value.actualCompanyTypeId,
        rcNumber: this.companyDirectorForm.value.rcNumber,
      })
      .subscribe(
        (res: any) => {
          this.callCompleted();
          this.company = res;
          this.companyDirectorForm
            .get('companyName')
            .setValue(res.approvedName);
          this.companyDirectorForm
            .get('companyRegNumber')
            .setValue(res.rcNumber);
          this.step++;
        },
        () => {
          this.callCompleted();
          this.error = 'Company not found';
        }
      );
  }

  getCompanyOwnershipTypes() {
    this.callStarted();
    this.commonService
      .getOption({
        params: new AppFilter({
          _search: true,
          rows: 100,
          filters: JSON.stringify({
            groupOp: 'AND',
            rules: [
              {
                field: 'optionType.optionTypeId',
                op: 'eq',
                data: 'ownership_type',
              },
            ],
          }),
        }),
      })
      .subscribe(
        (res: any) => {
          this.companyOwnershipTypes = res.rows;
          this.callCompleted();
        },
        () => {
          this.callCompleted();
          this.error = 'Error while fetching company ownership types';
        }
      );
  }

  getCompanyTypes() {
    this.callStarted();
    this.commonService
      .getOption({
        params: new AppFilter({
          _search: true,
          rows: 100,
          filters: JSON.stringify({
            groupOp: 'AND',
            rules: [
              {
                field: 'optionType.optionTypeId',
                op: 'eq',
                data: 'actual_company_type',
              },
            ],
          }),
        }),
      })
      .subscribe(
        (res: any) => {
          this.companyTypes = res.rows;
          this.callCompleted();
        },
        () => {
          this.callCompleted();
          this.error = 'Error while fetching company types';
        }
      );
  }

  getBizProvider() {
    this.callStarted();
    this.commonService
      .getOption({
        params: new AppFilter({
          _search: true,
          rows: 100,
          filters: JSON.stringify({
            groupOp: 'AND',
            rules: [
              {
                field: 'optionType.optionTypeId',
                op: 'eq',
                data: 'foreign_company_providers',
              },
            ],
          }),
        }),
      })
      .subscribe(
        (res: any) => {
          this.bizProvider = res.rows;
          // console.log(res);
          this.callCompleted();
        },
        () => {
          this.callCompleted();
          this.error = 'Error while fetching business information provider';
        }
      );
  }

  getMeansOfIdentificationText() {
    return `${
      this.meansOfIdentifications.find(
        (item) =>
          item.optionId ===
          this.companyDirectorForm.get('meansOfIdentificationId').value
      )?.optionName
    } (Photo of a slip, ID Card, front and back)`;
  }

  getMeansOfIdentification() {
    this.callStarted();
    this.commonService
      .getOption({
        params: new AppFilter({
          _search: true,
          rows: 100,
          filters: JSON.stringify({
            groupOp: 'AND',
            rules: [
              {
                field: 'optionType.optionTypeId',
                op: 'eq',
                data: 'identification_means',
              },
            ],
          }),
        }),
      })
      .subscribe(
        (res: any) => {
          this.meansOfIdentifications = res.rows;
          // console.log(res);
          this.callCompleted();
        },
        () => {
          this.callCompleted();
          this.error = 'Error while fetching company types';
        }
      );
  }

  calculateShareholding(shareAllocated: string) {
    const numericShareAllocated = parseFloat(shareAllocated.replace(/,/g, ''));
    if (numericShareAllocated && this.shareHoldingAmount) {
      const shareholding =
        (numericShareAllocated / this.shareHoldingAmount) * 100;
      this.companyDirectorForm.get('shareholding').setValue(shareholding);
    } else {
      this.companyDirectorForm.get('shareholding').setValue(0);
    }
  }
  editShares() {
    this.modalService
      .open(
        new EditSharesModal(
          'Edit Total Share Capital',
          this.shareHoldingAmount,
          ModalSize.Mini
        )
      )
      .onApprove((payload) => {
        this.shareHoldingAmount = payload;
        this.companyDirectorForm.get('shareCapital').setValue(payload);
      })
      .onDeny(() => {});
  }
  onFileChangeData(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    if (this.isFileTypeAllowed(files[0])) {
      this.selectedFilePhoto = files[0];
      this.fileNamePhoto = this.selectedFilePhoto['name'];
      this.previewImage(this.selectedFilePhoto);
    } else {
      this.error =
        'Invalid file type. Please select a .jpg, .jpeg, or .png file.';
      return;
    }
  }
  getDocumentPath(data) {
    this.callStarted();
    this.AolService.getDocument({ documentId: data }).subscribe(
      (res: any) => {
        this.callCompleted();
        this.fileNamePhoto = res.documentPath.split('______')[1];
        this.imageUrl = `${this.baseUrl}/public/image/?media=${res.documentPath}`;
      },
      (error) => {
        this.callCompleted();
        this.error = error.error;
      }
    );
  }
  isFileTypeAllowed(file: File): boolean {
    const allowedTypes = ['.jpg', '.jpeg', '.png'];
    const fileType = '.' + file.name.split('.').pop();
    return allowedTypes.includes(fileType.toLowerCase());
  }
  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageUrl = e.target?.result;
    };
    reader.readAsDataURL(file);
  }
  ngOnInit() {
    this.getAffiliateTypes(this.companyType);
    this.companyDirectorForm.valueChanges.subscribe(() => {
      this.checkBtnDisabled();
      this.checkStep1BtnDisabled();
    });

    // Add subscription to phone number field to automatically remove non-numeric characters
    this.companyDirectorForm
      .get('phoneNumber')
      .valueChanges.subscribe((value) => {
        if (value) {
          const numericValue = value.replace(/[^0-9]/g, '');
          if (numericValue !== value) {
            this.companyDirectorForm
              .get('phoneNumber')
              .setValue(numericValue, { emitEvent: false });
          }
        }
      });
  }

  checkBtnDisabled() {
    if (this.pendingArr.length) {
      this.isAddBtnDisabled = true;
      return;
    }

    if (!this.companyDirectorForm.valid && this.linkOrAddValue === 'add') {
      this.isAddBtnDisabled = true;
      return;
    }

    if (
      this.linkOrAddValue === 'link' &&
      (this.companyDirectors.every((director) => !director.checkbox) ||
        !this.companyDirectorForm.value.shareAllocated ||
        this.companyDirectorForm.value.shareAllocated === 0 ||
        !this.companyDirectorForm.value.companyRegNumber)
    ) {
      this.isAddBtnDisabled = true;
      return;
    }

    if (this.modal.context.isEdit) {
      if (this.companyDirectorForm.valid) {
        this.isAddBtnDisabled = false;
        return;
      }
    }

    // if (!this.companyDirectorForm.valid) {
    //   this.isAddBtnDisabled = true;
    //   return;
    // }

    if (
      !this.modal.context.isEdit &&
      this.step === 3 &&
      this.linkOrAddValue === 'add'
    ) {
      if (this.companyDirectorForm.get('nationalityId').value === 'NG') {
        if (
          this.supportingDocuments.length === 0 ||
          !this.companyDirectorForm.get('nationalIdNumber').value
        ) {
          this.isAddBtnDisabled = true;
          return;
        }
      }

      if (this.companyDirectorForm.get('nationalityId').value !== 'NG') {
        if (
          this.supportingDocuments.length < 1 ||
          !this.companyDirectorForm.get('meansOfIdentificationId').value ||
          !this.companyDirectorForm.get('identificationNumber').value
        ) {
          this.isAddBtnDisabled = true;
          return;
        }
      }
    }

    this.isAddBtnDisabled = false;
  }

  getAffiliateTypes(companyTypeId: string) {
    if (companyTypeId === 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }

    this.callStarted();
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId })
      .pipe(
        tap((companyAffiliateTypes: any) => {
          this.companyAffiliateTypes = companyAffiliateTypes;
        }),
        switchMap(() =>
          forkJoin({
            allAffiliateTypes: this.companyOwnershipService.getOwnershipTypes(),
          })
        )
      )
      .subscribe(
        (res: any) => {
          this.callCompleted();
          this.allAffiliateTypes = res?.allAffiliateTypes;

          this.companyAffiliateTypes.forEach((c) => {
            const match = res?.allAffiliateTypes.find(
              (a) => a.optionName === c.ownershipType
            );
            if (match) {
              c.ownershipTypeId = match.optionId;
            }
          });

          this.companyAffiliateTypes = this.companyAffiliateTypes.filter(
            (c) => c.ownershipTypeId !== this.affiliateTypeId
          );

          this.companyAffiliateTypes?.forEach((c) =>
            this.getPage(1, c.ownershipTypeId)
          );
        },
        (err) => {
          this.callCompleted();
        }
      );
  }

  uploadImage($event: File) {
    const fileSizeMB = this.getFileSize($event.size);
    if (fileSizeMB > 1) {
      this.supportingDocumentError =
        'File size is too large, Maximum file size is 1MB';
      return;
    }

    // if (this.companyDirectorForm.get('nationalityId').value === 'NG') {
    //   if (this.modal.context.isEdit) {
    //     this.documents = [null, null];
    //   }

    //   return;
    // }

    if (this.modal.context.isEdit) {
      const allDocuments = [...this.documents, ...this.supportingDocuments];
      if (allDocuments.filter((item) => item !== null).length > 1) {
        this.supportingDocumentError = 'You can only upload 2 documents';
        return;
      }
    }

    if (this.supportingDocuments.length == 2) {
      this.supportingDocumentError = 'You can only upload 2 documents';
      return;
    }

    this.supportingDocumentError = '';
    this.supportingDocuments.push($event);
    this.checkBtnDisabled();
  }

  viewFiles(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const blob = new Blob([e.target.result], { type: file.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    };
    reader.readAsArrayBuffer(file); // Use readAsArrayBuffer for binary data
  }

  viewDocument(document: any): void {
    const url = `${this.baseUrl}/public/image/?media=${document.documentPath}`;
    window.open(url, '_blank');
  }

  removeFile(fileIndex: number): void {
    this.supportingDocuments.splice(fileIndex, 1);
    this.checkBtnDisabled();
  }

  removeDocument(documentIndex: number): void {
    this.documents[documentIndex] = null;
    this.checkBtnDisabled();
  }

  getPage(page, ownershipType) {
    this.filter.page = page;
    this.callStarted();
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        ownershipType: ownershipType,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.callCompleted();

          const directorExists = (newDirector, existingDirectors) => {
            if (!existingDirectors || !Array.isArray(existingDirectors)) {
              return false;
            }

            return existingDirectors.some(
              (director) =>
                director.firstName === newDirector.firstName &&
                director.lastName === newDirector.lastName
            );
          };
          const newCheckDirectors = res.rows.filter(
            (newDirector) => !directorExists(newDirector, this.companyDirectors)
          );
          const newDirectors = newCheckDirectors.filter(
            (newDirector) => !directorExists(newDirector, this.previousDirector)
          );
          this.companyDirectors = this.companyDirectors.concat(res.rows);
          if (
            this.modal.context.isEdit &&
            this.modal.context.data.director.photographDocumentId
          ) {
            this.getDocumentPath(
              this.modal.context.data.director.photographDocumentId
            );
          }
        },
        (error) => {
          this.callCompleted();
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
  submit() {
    if (
      this.linkOrAddValue === 'link' &&
      this.affiliateTypeId === 'shareholder_type'
    ) {
      if (!this.usePercentage && this.affiliateTypeId === 'shareholder_type') {
        if (
          this.shareHoldingAmount <
            Number(this.companyDirectorForm.value.shareAllocated) ||
          this.shareHoldingAmount === 0 ||
          Number(this.companyDirectorForm.value.shareholding) > 100
        ) {
          this.showCapital = true;
          return;
        }
      }
      this.submitExistingShareholder();
      return;
    }
    if (
      this.linkOrAddValue === 'link' &&
      this.affiliateTypeId !== 'shareholder_type'
    ) {
      this.existingSubmission();
    }
    if (!this.usePercentage && this.affiliateTypeId === 'shareholder_type') {
      if (
        this.shareHoldingAmount <
          Number(this.companyDirectorForm.value.shareAllocated) ||
        this.shareHoldingAmount === 0 ||
        Number(this.companyDirectorForm.value.shareholding) > 100
      ) {
        this.showCapital = true;
        return;
      }
    }
    this.newSubmission();
    return;
  }
  async newSubmission() {
    if (!this.modal.context.isEdit) {
      if (this.selectedFilePhoto && !this.getFileSizePhotograph(this.selectedFilePhoto.size)) {
        this.error = `File (${this.selectedFilePhoto?.name}) size is too large, Maximum file size is 1MB`;
        return;
      }
      this.callStarted();

      await this.uploadDocuments();
      this.callCompleted();

      this.saveAction();
    } else if (this.modal.context.isEdit) {
      this.callStarted();
      if (this.selectedFilePhoto || this.supportingDocuments.length > 0) {
        await this.uploadDocuments();
      }
      this.callCompleted();

      this.saveAction();
    } else {
      this.error = `Please Upload a Profile Photo`;
      return;
    }
  }

  uploadDocuments(): Promise<void> {
    return new Promise((resolve, reject) => {
      // Create an array to store all upload promises
      const uploadPromises: Promise<void>[] = [];

      if (this.selectedFilePhoto) {
        // Upload profile photo
        const profilePhotoPromise = new Promise<void>(
          (resolvePhoto, rejectPhoto) => {
            let data: any = this.replyForm.value;
            const formData: FormData = new FormData();
            formData.append(
              'file',
              this.selectedFilePhoto,
              this.selectedFilePhoto.name
            );
            let payload: any = { formValue: data, formData: formData };
            this.uploadFormData = payload['formData'];
            const values = payload['formValue'];
            const jsonse = JSON.stringify(values);
            const blob = new Blob([jsonse], { type: 'application/json' });
            this.uploadFormData.append('data', blob);

            // Convert onUploadFilePhoto to return a Promise
            this.documentSvc
              .uploadDocument({
                organizationId: this.organizationId,
                body: this.uploadFormData,
              })
              .subscribe(
                (result: any) => {
                  this.companyDirectorForm.value['photographDocumentId'] =
                    result.documentId || result.photographDocumentId;
                  this.companyDirectorForm.value['photographDocumentPath'] =
                    result.documentPath || result.photographDocumentPath;
                  resolvePhoto();
                },
                (error) => {
                  this.error = 'Error while uploading profile photo';
                  rejectPhoto(error);
                }
              );
          }
        );
        uploadPromises.push(profilePhotoPromise);
      }

      if (this.supportingDocuments.length > 0) {
        // Upload supporting documents
        this.supportingDocuments.forEach((document, index) => {
          const supportingDocPromise = new Promise<void>(
            (resolveDoc, rejectDoc) => {
              let data: any = this.replyForm.value;
              const formData: FormData = new FormData();
              formData.append('file', document, document.name);
              let payload: any = { formValue: data, formData: formData };
              this.uploadFormData = payload['formData'];
              const values = payload['formValue'];
              const jsonse = JSON.stringify(values);
              const blob = new Blob([jsonse], { type: 'application/json' });
              this.uploadFormData.append('data', blob);

              this.documentSvc
                .uploadDocument({
                  organizationId: this.organizationId,
                  body: this.uploadFormData,
                })

                .subscribe(
                  (result: any) => {
                    if (this.modal.context.isEdit) {
                      const documentIndex = this.documents.findIndex(
                        (item) => item === null
                      );
                      this.companyDirectorForm.value[
                        `identificationDocument${documentIndex + 1}Id`
                      ] = result.documentId;
                      this.companyDirectorForm.value[
                        `identificationDocument${documentIndex + 1}Path`
                      ] = result.documentPath;
                      this.documents[documentIndex] = result;
                      this.supportingDocuments =
                        this.supportingDocuments.filter(
                          (item) => item !== document
                        );
                    } else {
                      this.companyDirectorForm.value[
                        `identificationDocument${index + 1}Id`
                      ] = result.documentId;
                      this.companyDirectorForm.value[
                        `identificationDocument${index + 1}Path`
                      ] = result.documentPath;
                    }

                    resolveDoc();
                  },
                  (error) => {
                    this.error = 'Error while uploading supporting document';
                    rejectDoc(error);
                  }
                );
            }
          );
          uploadPromises.push(supportingDocPromise);
        });
      }

      // Wait for all uploads to complete
      Promise.all(uploadPromises)
        .then(() => {
          this.callCompleted();
          resolve();
        })
        .catch((error) => {
          this.callCompleted();
          reject(error);
        });
    });
  }

  showSupportingDocuments() {
    if (!this.companyDirectorForm.get('nationalityId').value) return false;
    if (this.companyDirectorForm.get('nationalityId').value === 'NG')
      return true;
    if (this.companyDirectorForm.get('meansOfIdentificationId').value)
      return true;
    return false;
  }

  getChosenExistingResult() {
    return this.companyDirectors.filter((item) => item.checkbox)[0];
  }
  submitExistingShareholder() {
    this.resultToBeAdded = this.companyDirectors.filter(
      (item) => item.checkbox
    );
    if (this.resultToBeAdded.length > 0) {
      this.resultToBeAdded.map((item) => {
        item.actionType = this.modal.context.isEdit ? 'UPDATE' : 'LINK';
        item.shareholding = this.companyDirectorForm.value.shareholding;
        item.shareCapital = this.companyDirectorForm.value.shareCapital;
        item.shareAllocated = this.companyDirectorForm.value.shareAllocated;
        item.companyName = this.companyDirectorForm.value.companyName;
        item.companyRegNumber = this.companyDirectorForm.value.companyRegNumber;
        item.companyOwnershipTypeId =
          this.companyDirectorForm.value.companyOwnershipTypeId;
        item.actualCompanyTypeId =
          this.companyDirectorForm.value.actualCompanyTypeId;
        item.businessInformationProviderId =
          this.companyDirectorForm.value.businessInformationProviderId;
        item.businessInformationProvider =
          this.companyDirectorForm.value.businessInformationProvider;
      });
      this.success = `Record ${
        this.modal.context.isEdit ? 'Updated' : 'Added'
      }`;
      setTimeout(() => {
        this.modal.approve(this.resultToBeAdded);
        return;
      }, 3000);
    } else {
      this.error = `Please Select an Existing structure`;
      return;
    }
  }
  existingSubmission() {
    this.resultToBeAdded = this.companyDirectors.filter(
      (item) => item.checkbox
    );
    if (this.resultToBeAdded.length > 0) {
      this.resultToBeAdded.map((item) => {
        item.ownershipTypeIdName = [
          {
            [this.affiliateTypeId]: this.typeName,
          },
        ];
        item.actionType = 'UPDATE';
      });
      this.success = `Record ${
        this.modal.context.isEdit ? 'Updated' : 'Added'
      }`;
      setTimeout(() => {
        this.modal.approve(this.resultToBeAdded);
        return;
      }, 3000);
    } else {
      this.error = `Please Select an Existing structure`;
      return;
    }
  }

  getFileSize(fileInput: number) {
    const fileSizeBytes = fileInput;
    const fileSizeKB = fileSizeBytes / 1024;
    const fileSizeMB = fileSizeKB / 1024;
    return fileSizeMB;
  }

  getFileSizePhotograph(fileInput: number) {
    const fileSizeMB = this.getFileSize(fileInput || 0);
    if (fileSizeMB > 1) {
      return false;
    } else {
      return true;
    }
  }

  saveAction() {
    this.resultToBeAdded = [];
    console.log(this.companyDirectorForm.value);
    if (this.companyDirectorForm.value.organizationOwnershipId) {
      this.companyDirectorForm.value.actionType = this.modal.context.isEdit
        ? 'UPDATE'
        : 'ADD';
    } else {
      this.companyDirectorForm.value.actionType = 'ADD';
    }

    (this.companyDirectorForm.value.createdBy = JSON.stringify({
      name: this.organization.firstName + ' ' + this.organization.lastName,
      username: this.organization.username,
      appUserId: this.organization.appUserId,
      organizationId: this.organization.organizationId.organizationId,
      organizationName: this.organization.organizationId.organizationShortName,
    })),
      (this.companyDirectorForm.value.dateCreated = new Date().toISOString()),
      this.resultToBeAdded.push(this.companyDirectorForm.value);
    this.success = `Record ${this.modal.context.isEdit ? 'Updated' : 'Added'}`;
    setTimeout(() => {
      this.modal.approve(this.resultToBeAdded);
      return;
    }, 3000);
  }
  isFieldValid(field: string) {
    if (field === 'shareholding') {
      if (this.companyDirectorForm.get(field).value > 100) {
        return true;
      }
    }

    if (field === 'shareAllocated') {
      if (this.companyDirectorForm.get(field).value > this.shareHoldingAmount) {
        return true;
      }
    }
    return (
      (!this.companyDirectorForm.get(field).valid &&
        this.companyDirectorForm.get(field).touched) ||
      (this.companyDirectorForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  onBoxChecked(selectedDirector: any, isChecked: boolean) {
    if (isChecked) {
      this.companyDirectors.forEach((director) => {
        if (director !== selectedDirector) {
          director.checkbox = false;
        }
      });
    }
    // selectedDirector.checkbox = isChecked;
    // console.log(selectedDirector, this.companyDirectors);
    this.checkBtnDisabled();
  }
  deleteImage(event: Event) {
    event.stopPropagation();
    this.imageUrl = null;
    this.fileNamePhoto = null;
  }

  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }
}

export class NewCompanyModal extends ComponentModalConfig<
  INewDirectorModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Mini
  ) {
    super(NewCompanyModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
